import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthenticationTypeEnum, SigningStatusEnum } from '../enums/enum';
import { RoleDetail } from '../signing-page/signing-page.dto';
import { VerificationPage } from './verification-page-dto';
import { VerificationPageService } from './verification-page.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-verification-page',
  templateUrl: './verification-page.component.html',
  styleUrl: './verification-page.component.scss',
  encapsulation: ViewEncapsulation.None

})
export class VerificationPageComponent implements OnInit {
  @Input() roleId:string;
  @Input() document_id:number;
  @Input() is_sender:number;
  @Input() roleDetail: RoleDetail;
  constructor(
    private verificationPageService: VerificationPageService 
  ){}
  public verification:VerificationPage;
  public loadVerification:boolean = true;
  public authenticationTypeEnum = AuthenticationTypeEnum;
  public signingStatusEnum = SigningStatusEnum;
  public status = {
    'signed' : 'signer',
    'viewed' : 'viewer',
    'approved' : 'approver',
    'forward' : 'forwarder',
    'read_only' : 'reader'
  }
  public appUrl:string = environment.appUrl;
  ngOnInit(): void {
    this.getVerfication();
  }

  getVerfication(){
    this.verificationPageService.verification(this.roleId, this.document_id).subscribe({
      next: (verification:VerificationPage) => {
        this.verification = verification;
        this.loadVerification = false;
      },
      error: () => {
        this.loadVerification = false;
      }  
    })
  }
}
